export const IMPORTER_GET = 'IMPORTER_GET';
export const IMPORTER_CLEAR = 'IMPORTER_CLEAR';
export const IMPORTER_LIST = 'IMPORTER_LIST';

export const IMPORTER_SCRIPT_CLEAR = 'IMPORTER_SCRIPT_CLEAR';
export const IMPORTER_SCRIPT_LIST = 'IMPORTER_SCRIPT_LIST';